import React from "react";
import { fileUrl } from "../../lib/api";
import { Reveal, Overline } from "./Reveal";

export default function PageHeader({ overline, title, subtitle, image }) {
  return (
    <section className="relative pt-40 pb-20 sm:pt-48 sm:pb-28 overflow-hidden bg-velvet" data-testid="page-header">
      {image && <img src={fileUrl(image)} alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />}
      <div className="absolute inset-0 bg-gradient-to-t from-velvet via-burgundy/50 to-burgundy/70" />
      <div className="relative max-w-[1400px] mx-auto px-4 sm:px-8">
        <Reveal>
          <Overline>{overline}</Overline>
          <h1 className="font-serif text-ivory text-4xl sm:text-6xl lg:text-7xl mt-5 leading-[1.03] max-w-4xl">{title}</h1>
          {subtitle && <p className="text-ivory/70 mt-5 max-w-xl text-base sm:text-lg">{subtitle}</p>}
        </Reveal>
      </div>
    </section>
  );
}
